import { IResponse } from "models";

export enum ActionType {
  STRESS_CHECK_DETAILS = "action/STRESS_CHECK_DETAILS",
  STRESS_CHECK_DETAILS_SUCCESS = "action/STRESS_CHECK_DETAILS_SUCCESS",
  STRESS_CHECK_DETAILS_ERROR = "action/STRESS_CHECK_DETAILS_ERROR",
  STRESS_CHECK_DETAILS_RESET_DATA = "action/STRESS_CHECK_DETAILS_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface StressCheckDetailsData {
  id?: number;
  language_code?: string;
}

export interface IStressCheckDetailsResponse extends IResponse {
  result?: Details;
}

export interface Details {
  id?: number;
  name: string;
  stress_check_type_id: number;
  examination_period: string;
  status: number;
  implement_status: string;
  color_code_status: string;
}
